















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import AppConsts from "@/lib/appconst";
import PagedFilterAndSortedRequest from "@/store/entities/page-request";
import pagelist from "@/components/pagelistcomponent";
import edit from "./MerchantAndMerBinDingsEdit.vue"
@Component({
  components: { edit},
})
export default class suppliermanage extends pagelist {
  get prox() {
    return new proxy.MerchantAndMerBinDingServiceProxy();
  }
  createOrEditShow = false;
  sub_id = 0;
  merchantStatisticsShow = false;
  input: proxy.MerchantAndMerBinDingPageInputDto = new proxy.MerchantAndMerBinDingPageInputDto();
  pageSize = 50
  columns = [
    {
      type: "selection",
      width: 60,
      align: "center",
      fixed: "left",
    },
    {
      title: "一键登录名称",
      key: "name",
    },{
      title:"创建时间",
      slot:"creationTime"
    }
  
  ];
  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.prox.queryModelList(this.input).then((x) => {

      this.dataList = x.items;
      this.showPaging(x);
    });
  }

  getpage() {
    this.OnInit();
  }
  async created() {
    this.getpage();
  }
  create() {
    this.createOrEditShow = true;
    this.sub_id = undefined;
  }
  edit(row) {
    if (!row) {
      if (this.selectedDataItems.length == 0) {
        this.$Notice.error({ title: "请选中一条数据" });
        return;
      }
      row = this.selectedDataItems[0];
    }
    this.sub_id = row.id;
    this.createOrEditShow = true;
  }
  del() {
  if (this.selectedDataItems.length == 0) {
    this.$Notice.error({ title: "请选中一条数据" });
    return;
  }

  this.$Modal.confirm({
    title: "你确定要删除吗?删除后将无法恢复",
    onOk: () => {
      this.prox
        .deletes(
          this.selectedDataItems.map((x) => {
            return x.id;
          })
        )
        .then(() => {
          this.$Notice.success({ title: "删除成功" });
          this.getpage();
        });
    },
  });
}
}
